import { render, staticRenderFns } from "./SportCard.vue?vue&type=template&id=2e4b27ad&scoped=true&"
import script from "./SportCard.vue?vue&type=script&lang=ts&"
export * from "./SportCard.vue?vue&type=script&lang=ts&"
import style0 from "./SportCard.vue?vue&type=style&index=0&id=2e4b27ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4b27ad",
  null
  
)

export default component.exports